"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
var angular = require("angular");
var bucket_chart_chart_1 = require("./bucket-chart.chart");
var basic_chart_component_1 = require("../basic-component/basic-chart.component");
var COMPONENT_NAME = 'smartorg.r6.acts.bucketChart';
var BucketChartComponent = /** @class */ (function (_super) {
    __extends(BucketChartComponent, _super);
    function BucketChartComponent($scope, $timeout) {
        var _this = 
        // This constructor is necessary for inject scope and timeout.
        _super.call(this, $scope, $timeout, 'BucketChart') || this;
        var ctrl = _this;
        $scope.$on('command:BUCKET_CHART', function (event, args) { return ctrl.initComponent(event, args); });
        return _this;
    }
    BucketChartComponent.prototype.getChartOptions = function (graph, options) {
        return bucket_chart_chart_1.getChartOptions(graph, options);
    };
    BucketChartComponent.prototype.getAdditionalChartCallback = function () {
        return bucket_chart_chart_1.getAdditionalChartCallback();
    };
    BucketChartComponent = __decorate([
        basic_chart_component_1.Component({
            bindings: {
                menu: '='
            },
            template: require("./bucket-chart.component.html")
        }),
        __metadata("design:paramtypes", [Object, Object])
    ], BucketChartComponent);
    return BucketChartComponent;
}(basic_chart_component_1.BasicChartComponent));
exports.BucketChartComponent = BucketChartComponent;
angular.module(COMPONENT_NAME, []).component('bucketChart', BucketChartComponent);
exports["default"] = COMPONENT_NAME;
//# sourceMappingURL=bucket-chart.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/bucket-chart2/bucket-chart.component.js